import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from '../../../../../Containers/Config';
import { Constant } from '../../../../../Containers/Helpers/constant';
import apiCall from '../../../apiCall';
import { GET_LEDGER, GET_LEDGER_ERROR, GET_LEDGER_SUCCESS } from '../../../actionType';

function* getLedger({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/ledger`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        // 'Project-Code': 'GLOBE_TOYOTA',
        ...customHeaders,
      },
      data: payload?.data,
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_LEDGER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_LEDGER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_LEDGER_ERROR, payload: error });
  }
}

export function* watchgetLedger() {
  yield takeEvery(GET_LEDGER, getLedger);
}

function* getLedgerSaga() {
  yield all([fork(watchgetLedger)]);
}

export default getLedgerSaga;
